import {NgModule} from '@angular/core';
import {ConfiguratorPageEventModule} from '@app/services/analytics/EDDL/events/configurator-page-event.module';
import {CartBaseFeatureModule} from '@app/spartacus/features/cart/cart-base-feature.module';
import {CdsFeatureModule} from '@app/spartacus/features/cds/cds-feature.module';
import {CheckoutFeatureModule} from '@app/spartacus/features/checkout/checkout-feature.module';
import {OrderFeatureModule} from '@app/spartacus/features/order/order-feature.module';
import {OrganizationAdministrationFeatureModule} from '@app/spartacus/features/organization/organization-administration-feature.module';
import {OrganizationOrderApprovalFeatureModule} from '@app/spartacus/features/organization/organization-order-approval-feature.module';
import {ProductConfiguratorFeatureModule} from '@app/spartacus/features/product-configurator/product-configurator-feature.module';
import {TagManagementFeatureModule} from '@app/spartacus/features/tracking/tag-management-feature.module';
import {
  AuthModule,
  CostCenterOccModule,
  ExternalRoutesModule,
  ProductModule,
  ProductOccModule,
  provideConfig,
  UserModule,
  UserOccModule,
} from '@spartacus/core';
import {
  BannerCarouselModule,
  BannerModule,
  BreadcrumbModule,
  CategoryNavigationModule,
  CmsParagraphModule,
  ConsentManagementModule,
  FooterNavigationModule,
  HamburgerMenuModule,
  HomePageEventModule,
  LinkModule,
  LoginRouteModule,
  LogoutModule,
  MyCouponsModule,
  MyInterestsModule,
  NavigationEvent,
  NavigationEventModule,
  NavigationModule,
  NotificationPreferenceModule,
  PageEvent,
  PaymentMethodsModule,
  ProductCarouselModule,
  ProductDetailsPageModule,
  ProductFacetNavigationModule,
  ProductImagesModule,
  ProductIntroModule,
  ProductListingPageModule,
  ProductListModule,
  ProductPageEventModule,
  ProductReferencesModule,
  ProductSummaryModule,
  ProductTabsModule,
  SearchBoxModule,
  SiteContextSelectorModule,
  StockNotificationModule,
  TabParagraphContainerModule,
} from '@spartacus/storefront';
import {TmsConfig} from '@spartacus/tracking/tms/core';
import {AddressBookModule} from '@spartacus/user/profile/components';
import {DcpEddlAddToCartService} from '../services/analytics/EDDL/dcp-eddl-add-to-cart.service';
import {DcpEddlCartCreatedService} from '../services/analytics/EDDL/dcp-eddl-cart-created.service';
import {DcpEddlCartStateService} from '../services/analytics/EDDL/dcp-eddl-cart-state.service';
import {DcpEddlCollectorService} from '../services/analytics/EDDL/dcp-eddl-collector.service';
import {DcpEddlDownloadEventService} from '../services/analytics/EDDL/dcp-eddl-download-event.service';
import {DcpEddlECommerceDataService} from '../services/analytics/EDDL/dcp-eddl-ecommerce-data.service';
import {DcpEddlErrorPageViewDataLayerService} from '../services/analytics/EDDL/dcp-eddl-error-page-view-data-layer.service';
import {DcpEddlFormErrorService} from '../services/analytics/EDDL/dcp-eddl-form-error.service';
import {DcpEddlFormSubmitService} from '../services/analytics/EDDL/dcp-eddl-form-submit.service';
import {DcpEddlFormViewService} from '../services/analytics/EDDL/dcp-eddl-form-view.service';
import {DcpEddlGlobalDataLayerService} from '../services/analytics/EDDL/dcp-eddl-global-data-layer.service';
import {DcpEddlLoginDataService} from '../services/analytics/EDDL/dcp-eddl-login-data.service';
import {DcpEddlLoginStateService} from '../services/analytics/EDDL/dcp-eddl-login-state.service';
import {DcpEddlLogoutDataService} from '../services/analytics/EDDL/dcp-eddl-logout-data.service';
import {DcpEddlPageViewService} from '../services/analytics/EDDL/dcp-eddl-page-view.service';
import {DcpEddlRemoveFromCartService} from '../services/analytics/EDDL/dcp-eddl-remove-from-cart.service';
import {DcpEddlSearchDataService} from '../services/analytics/EDDL/dcp-eddl-search-data-service';
import {DcpEddlStBeaconReadyDataLayerService} from '../services/analytics/EDDL/dcp-eddl-st-beacon-ready-data-layer.service';
import {AfterPageViewEvent} from '../services/analytics/EDDL/events/after-page-view-event';
import {EddlAddToCartEvent} from '../services/analytics/EDDL/events/eddl-add-to-cart-event';
import {EddlAfterInitializationEvent} from '../services/analytics/EDDL/events/eddl-after-initialization-event';
import {EddlCartCreatedEvent} from '../services/analytics/EDDL/events/eddl-cart-created-event';
import {EddlCartViewEvent} from '../services/analytics/EDDL/events/eddl-cart-view-event';
import {EddlCheckoutStartEvent} from '../services/analytics/EDDL/events/eddl-checkout-start-event';
import {EddlDownloadAttemptEvent} from '../services/analytics/EDDL/events/eddl-download-attempt-event';
import {EddlDownloadSuccessEvent} from '../services/analytics/EDDL/events/eddl-download-success-event';
import {EddlFormErrorEvent} from '../services/analytics/EDDL/events/eddl-form-error-event';
import {EddlFormSubmitEvent} from '../services/analytics/EDDL/events/eddl-form-submit-event';
import {EddlFormViewEvent} from '../services/analytics/EDDL/events/eddl-form-view-event';
import {EddlInitializationEvent} from '../services/analytics/EDDL/events/eddl-initialization-event';
import {EddlLoginEvent} from '../services/analytics/EDDL/events/eddl-login-event';
import {EddlLogoutEvent} from '../services/analytics/EDDL/events/eddl-logout-event';
import {EddlOrderCompleteEvent} from '../services/analytics/EDDL/events/eddl-order-complete-event';
import {EddlRemoveFromCartEvent} from '../services/analytics/EDDL/events/eddl-remove-from-cart-event';
import {EddlSearchInitiatedEvent} from '../services/analytics/EDDL/events/eddl-search-initiated-event';
import {EddlSearchNoResultsEvent} from '../services/analytics/EDDL/events/eddl-search-no-results-event';
import {EddlSearchResultsClickEvent} from '../services/analytics/EDDL/events/eddl-search-results-click-event';
import {EddlSearchFilterAppliedEvent} from '../services/analytics/EDDL/events/eddl-search-filter-applied-event';
import {EddlSearchFilterRemovedEvent} from '../services/analytics/EDDL/events/eddl-search-filter-removed-event';
import {EddlSearchFilterClearedEvent} from '../services/analytics/EDDL/events/eddl-search-filter-cleared-event';
import {EddlStBeaconEvent} from '../services/analytics/EDDL/events/eddl-stbeacon-event';
import {EddlStlBeaconEvent} from '../services/analytics/EDDL/events/eddl-stlbeacon-event';
import {ErrorPageEvent} from '../services/analytics/EDDL/events/error-page-event';
import {DCP_EDDL_DATA_LAYER_SERVICE} from '../services/analytics/EDDL/tokens';
import {ProductVariantsFeatureModule} from './features/product/product-variants-feature.module';
import {SmartEditFeatureModule} from './features/smartedit/smart-edit-feature.module';
import {DcpDtrumTrackingFeatureWrapperModule} from './features/tracking/dcp-dtrum-tracking-feature-wrapper.module';
import {PersonalizationFeatureModule} from './features/tracking/personalization-feature.module';
import {UserFeatureModule} from './features/user/user-feature.module';
import {EddlProductViewEvent} from '@app/services/analytics/EDDL/events/eddl-product-view-event';
import {DcpEddlProductViewService} from '@app/services/analytics/EDDL/dcp-eddl-product-view.service';

@NgModule({
  declarations: [],
  imports: [
    AuthModule.forRoot(),
    LogoutModule,
    LoginRouteModule,
    HamburgerMenuModule,
    SiteContextSelectorModule,
    LinkModule,
    BannerModule,
    CmsParagraphModule,
    TabParagraphContainerModule,
    BannerCarouselModule,
    CategoryNavigationModule,
    NavigationModule,
    FooterNavigationModule,
    BreadcrumbModule,
    UserModule,
    UserOccModule,
    AddressBookModule,
    PaymentMethodsModule,
    NotificationPreferenceModule,
    MyInterestsModule,
    StockNotificationModule,
    ConsentManagementModule,
    MyCouponsModule,
    ProductModule.forRoot(),
    ProductOccModule,
    ProductDetailsPageModule,
    ProductListingPageModule,
    ProductListModule,
    SearchBoxModule,
    ProductFacetNavigationModule,
    ProductTabsModule,
    ProductCarouselModule,
    ProductReferencesModule,
    ProductImagesModule,
    ProductSummaryModule,
    ProductIntroModule,
    CostCenterOccModule,
    NavigationEventModule,
    HomePageEventModule,
    ProductPageEventModule,
    ExternalRoutesModule.forRoot(),
    UserFeatureModule,
    CartBaseFeatureModule,
    OrderFeatureModule,
    CheckoutFeatureModule,
    PersonalizationFeatureModule,
    TagManagementFeatureModule,
    ProductConfiguratorFeatureModule,
    CdsFeatureModule,
    SmartEditFeatureModule,
    ProductVariantsFeatureModule,
    OrganizationOrderApprovalFeatureModule,
    OrganizationAdministrationFeatureModule,
    // CUSTOM
    ConfiguratorPageEventModule,
    DcpDtrumTrackingFeatureWrapperModule,
  ],
  providers: [
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlGlobalDataLayerService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlPageViewService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlErrorPageViewDataLayerService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlStBeaconReadyDataLayerService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlLoginDataService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlLogoutDataService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlRemoveFromCartService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlAddToCartService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlSearchDataService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlECommerceDataService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlCartCreatedService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlFormSubmitService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlFormErrorService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlFormViewService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlDownloadEventService,
      multi: true,
    },
    {
      provide: DCP_EDDL_DATA_LAYER_SERVICE,
      useClass: DcpEddlProductViewService,
      multi: true,
    },
    provideConfig({
      tagManager: {
        eddl: {
          // scriptUrl: '//assets.adobedtm.com/ccc66c06b30b/345b878163b0/launch-e09dd1fc9c73-staging.min.js',
          collector: DcpEddlCollectorService,
          events: [
            EddlInitializationEvent,
            EddlAfterInitializationEvent,
            EddlCartViewEvent,
            NavigationEvent,
            PageEvent,
            ErrorPageEvent,
            EddlLogoutEvent,
            EddlLoginEvent,
            EddlSearchNoResultsEvent,
            EddlSearchResultsClickEvent,
            EddlSearchInitiatedEvent,
            EddlSearchFilterAppliedEvent,
            EddlSearchFilterRemovedEvent,
            EddlSearchFilterClearedEvent,
            EddlRemoveFromCartEvent,
            EddlAddToCartEvent,
            EddlCartCreatedEvent,
            EddlFormSubmitEvent,
            EddlCheckoutStartEvent,
            EddlOrderCompleteEvent,
            EddlFormErrorEvent,
            EddlFormViewEvent,
            EddlDownloadAttemptEvent,
            EddlDownloadSuccessEvent,
            EddlProductViewEvent,
            AfterPageViewEvent,
            EddlStBeaconEvent,
            EddlStlBeaconEvent,
          ],
        },
      },
    } as TmsConfig),
  ],
})
export class SpartacusFeaturesModule {
  constructor(_loginStateService: DcpEddlLoginStateService, _cartStateService: DcpEddlCartStateService) {}
}
